import React, { useEffect, createElement } from 'react';
import { TopBar } from './components/TopBar';
import { Hero } from './components/Hero';
import { SocialProofStrip } from './components/SocialProofStrip';
import { Benefits } from './components/Benefits';
import { Gallery } from './components/Gallery';
import { PersonalSection } from './components/PersonalSection';
import { KitContents } from './components/KitContents';
import { VideoSection } from './components/VideoSection';
import { PurchaseSection } from './components/PurchaseSection';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
import { SocialProofPopup } from './components/SocialProofPopup';
export function App() {
  useEffect(() => {
    // Meta Pixel
    const script = document.createElement('script');
    script.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '892577757067744');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(script);
    // Noscript fallback
    const noscript = document.createElement('noscript');
    const img = document.createElement('img');
    img.height = 1;
    img.width = 1;
    img.style.display = 'none';
    img.src = 'https://www.facebook.com/tr?id=892577757067744&ev=PageView&noscript=1';
    noscript.appendChild(img);
    document.body.appendChild(noscript);
    return () => {
      document.head.removeChild(script);
      document.body.removeChild(noscript);
    };
  }, []);
  return <div className="min-h-screen bg-brand-bg font-sans selection:bg-brand-cta selection:text-white" data-id="element-0">
      <TopBar data-id="element-1" />
      <main className="space-y-4 sm:space-y-8 pb-12 [&>section]:py-12 lg:[&>section]:py-16" data-id="element-2">
        <Hero data-id="element-3" />
        <SocialProofStrip data-id="element-4" />
        <Benefits data-id="element-5" />
        <Gallery data-id="element-6" />
        <PersonalSection data-id="element-7" />
        <KitContents data-id="element-8" />
        <VideoSection data-id="element-9" />
        <Testimonials data-id="element-10" />
        <PurchaseSection data-id="element-11" />
        <FAQ data-id="element-12" />
      </main>
      <Footer data-id="element-13" />
      <SocialProofPopup data-id="element-14" />
    </div>;
}